import { useCallback } from "react";
import {
  fetchOtherListings,
  pickDataForListing,
} from "../data/api/search";

export function useSellerData() {
  const fetchListings = useCallback(
    (
      slug: string,
      cursor: Parameters<typeof fetchOtherListings>[1],
      page: number,
      sold?: string
    ) => fetchOtherListings(slug, cursor, page, sold),
    []
  );

  const pickForListing = useCallback(
    (list: Parameters<typeof pickDataForListing>[0], max?: number) =>
      pickDataForListing(list, max),
    []
  );

  return {
    fetchOtherListings: fetchListings,
    pickDataForListing: pickForListing,
  };
}
